import { use, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import * as commonServices from '../services/website.services';
import { capitalizeFirstLetter, hideMainLoader, renderCmsContent, setTitle } from "../../../utils/commonfunction";
import { Placeholder } from "rsuite";
import { useSearchParams } from "react-router-dom";


const DynamicPages = () => {

    const params = useParams();
    const loc = useLocation();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState({});
    const [searchParams] = useSearchParams();
    const [showHeader, setShowHeader] = useState(false);


    useEffect(() => {
        setLoading(true);
        commonServices.cmsDetails(params?.slug).then((response) => {
            setData(response?.data);
            setTitle(response?.data?.title);
            setLoading(false);
            const appData = { action: 'stop-loader', data: {} };
            window.ReactNativeWebView?.postMessage(JSON.stringify(appData));
        }).catch((error) => {
            setLoading(false);
            console.log("error of terms&conditions", error);
        });
    }, [loc, params?.slug]);

    useEffect(() => {
        if (searchParams.get("header") == "false") {
            setShowHeader(false);
        } else {
            setShowHeader(true);
        }
        setTimeout(() => {
            hideMainLoader();
        }, 100);
    });

    return (
        <main>
            {loading ? (
                <section className="Conditions-item section-padding">
                    <div className="container website-placeholder" style={{ minHeight: '48vh' }}>
                        <Placeholder.Graph className="w-100 mb-5" active={true} />
                        <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={10} />
                    </div>
                </section>
            ) : (
                <>
                    {showHeader ?
                        <section className="page-title-bg m-[15px] bg-primary-50 rounded-[20px] py-8 md:py-12 mb-5">
                            <div className="container">
                                <div className="flex items-center justify-between flex-col gap-[15px]">
                                    <h1 className="heading-web-h1">{data && data?.title ? data?.title : ""}</h1>
                                    <ul className="flex items-center gap-[15px] m-0 p-0">
                                        <li><Link to="/" className="headings-h6 text-primary-400">Home</Link></li>
                                        <li><span className="bg-primary-400 w-[8px] h-[8px] rounded-full inline-block"></span></li>
                                        <li><span className="body-lg text-[var(--black-scale-900)]">{data && data?.title ? data?.title : ""}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </section>
                        : null
                    }
                    <div className="privacy-policy-bg py-8 pb-16">
                        <div className="container">
                            <div
                                className="body-lg text-black !leading-relaxed [&_a]:text-indigo-600 [&_a]:underline [&_a]:font-medium [&_a]:hover:text-indigo-800"
                                dangerouslySetInnerHTML={{ __html: renderCmsContent(data?.description) }}
                            ></div>
                        </div>
                    </div>
                </>
            )}
        </main>
    );
}

export default DynamicPages;
